import React, { Component } from 'react';
import moment from 'moment';
import StatisticsManager from './StatisticsManager';

export default class GoalContestManager {

    constructor() {

        this.statisticsManager = new StatisticsManager();

        this.generateDateObjects = this.generateDateObjects.bind(this);

        this.didGetTicket = this.didGetTicket.bind(this);
        this.generateMultiStoreBlastData = this.generateMultiStoreBlastData.bind(this);
        this.generateContestPeriodData = this.generateContestPeriodData.bind(this);
        this.generateContestPeopleData = this.generateContestPeopleData.bind(this);
        this.generateContestCompetitionResults = this.generateContestCompetitionResults.bind(this);
    }

    generateDateObjects(gForm, calendarDates, context) {
        let finalDateObject = {
            fromYear: [],
            fromMonth: [],
            fromDay: [],
            toYear: [],
            toMonth: [],
            toDay: [],
            phase: 0
        };

        let monthList = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC']

        let activeTimeFrame = '';
        let yearListFrom = [];
        let monthListFrom = [];
        let dayListFrom = [];
        let yearListTo = [];
        let monthListTo = [];
        let dayListTo = [];
        let yearListFromObjs = [];
        let monthListFromObjs = [];
        let dayListFromObjs = [];
        let yearListToObjs = [];
        let monthListToObjs = [];
        let dayListToObjs = [];

        let phase = 0;
        if (gForm.timeFrame != null) {
            phase = 1;

            activeTimeFrame = gForm.timeFrame.toLowerCase();
            yearListFrom = Object.keys(calendarDates[activeTimeFrame].start);

            yearListFrom.forEach((year) => {
                yearListFromObjs.push({
                    value: year,
                    text: year,
                    className: 'gc-calendar-item year',
                    isActive: year === context.state.fromYear,
                    onClick: context.selectFromYear.bind(null, year)
                });
            });
        } else {
            for (var i = 0; i < 5; i++) {
                yearListFromObjs.push({
                    value: '',
                    text: '',
                    className: 'gc-calendar-item year hidden',
                    isActive: false,
                    onClick: null
                });
            }
        }
        if (context.state.fromYear != null) {
            phase = 2;

            monthListFrom = Object.keys(calendarDates[activeTimeFrame].start[context.state.fromYear]);

            for (var i = 1; i <= 12; i++) {

                let iNum = ("0" + i).slice(-2);

                if (monthListFrom.includes(iNum)) {
                    monthListFromObjs.push({
                        value: iNum,
                        text: monthList[i - 1], //iNum,
                        className: 'gc-calendar-item month',
                        isActive: iNum === context.state.fromMonth,
                        onClick: context.selectFromMonth.bind(null, iNum)
                    });
                } else {
                    monthListFromObjs.push({
                        value: iNum,
                        text: monthList[i - 1], //iNum,
                        className: 'gc-calendar-item faded month',
                        isActive: iNum === context.state.fromMonth,
                        onClick: null
                    });
                }
            }

            yearListFromObjs.forEach((obj) => {
                if (obj.isActive) {
                    obj.className += ' active';
                    obj.onClick = context.selectFromYear.bind(null, null);
                } else {
                    obj.className += ' hidden';
                    obj.onClick = null;
                }
            });
        } else {
            for (var i = 0; i < 12; i++) {
                monthListFromObjs.push({
                    value: '',
                    text: '',
                    className: 'gc-calendar-item month hidden',
                    isActive: false,
                    onClick: null
                });
            }
        }
        if (context.state.fromMonth != null) {
            phase = 3;

            dayListFrom = calendarDates[activeTimeFrame].start[context.state.fromYear][context.state.fromMonth];

            let dayCount = new Date(parseInt(context.state.fromYear), parseInt(context.state.fromMonth), 0).getDate();
            for (var i = 1; i <= dayCount; i++) {

                let iNum = ("0" + i).slice(-2);

                if (dayListFrom.includes(iNum)) {
                    dayListFromObjs.push({
                        value: iNum,
                        text: iNum,
                        className: 'gc-calendar-item day',
                        isActive: iNum === context.state.fromDay,
                        onClick: context.selectFromDay.bind(null, iNum)
                    });
                } else {
                    dayListFromObjs.push({
                        value: iNum,
                        text: iNum,
                        className: 'gc-calendar-item faded day',
                        isActive: iNum === context.state.fromDay,
                        onClick: null
                    });
                }
            }

            monthListFromObjs.forEach((obj) => {
                if (obj.isActive) {
                    obj.className += ' active';
                    obj.onClick = context.selectFromYear.bind(null, context.state.fromYear);
                } else {
                    obj.className += ' hidden';
                    obj.onClick = null;
                }
            });
        } else {
            for (var i = 0; i < 31; i++) {
                dayListFromObjs.push({
                    value: '',
                    text: '',
                    className: 'gc-calendar-item day hidden',
                    isActive: false,
                    onClick: null
                });
            }
        }
        if (context.state.fromDay != null) {
            phase = 4;

            yearListTo = Object.keys(calendarDates[activeTimeFrame].end);

            yearListTo.forEach((year) => {
                if (parseInt(year) >= parseInt(context.state.fromYear)) {
                    yearListToObjs.push({
                        value: year,
                        text: year,
                        className: 'gc-calendar-item year',
                        isActive: year === context.state.toYear,
                        onClick: context.selectToYear.bind(null, year)
                    });
                }
            });

            dayListFromObjs.forEach((obj) => {
                if (obj.isActive) {
                    obj.className += ' active';
                    obj.onClick = context.selectFromMonth.bind(null, context.state.fromMonth);
                } else {
                    obj.className += ' hidden';
                    obj.onClick = null;
                }
            });
        } else {
            for (var i = 0; i < 5; i++) {
                yearListToObjs.push({
                    value: '',
                    text: '',
                    className: 'gc-calendar-item year hidden',
                    isActive: false,
                    onClick: null
                });
            }
        }
        if (context.state.toYear != null) {
            phase = 5;

            monthListTo = Object.keys(calendarDates[activeTimeFrame].end[context.state.toYear]);

            for (var i = 1; i <= 12; i++) {

                let iNum = ("0" + i).slice(-2);

                if (monthListTo.includes(iNum) &&
                    (parseInt(context.state.toYear) > parseInt(context.state.fromYear) ||
                        (parseInt(context.state.toYear) === parseInt(context.state.fromYear) && parseInt(iNum) >= parseInt(context.state.fromMonth)))) {
                    monthListToObjs.push({
                        value: iNum,
                        text: monthList[i - 1], //iNum,
                        className: 'gc-calendar-item month',
                        isActive: iNum === context.state.toMonth,
                        onClick: context.selectToMonth.bind(null, iNum)
                    });
                } else {
                    monthListToObjs.push({
                        value: iNum,
                        text: monthList[i - 1], //iNum,
                        className: 'gc-calendar-item faded month',
                        isActive: iNum === context.state.toMonth,
                        onClick: null
                    });
                }
            }

            yearListToObjs.forEach((obj) => {
                if (obj.isActive) {
                    obj.className += ' active-alt';
                    obj.onClick = context.selectFromDay.bind(null, context.state.fromDay);
                } else {
                    obj.className += ' hidden';
                    obj.onClick = null;
                }
            });
        } else {
            for (var i = 0; i < 12; i++) {
                monthListToObjs.push({
                    value: '',
                    text: '',
                    className: 'gc-calendar-item month hidden',
                    isActive: false,
                    onClick: null
                });
            }
        }
        if (context.state.toMonth != null) {
            phase = 6;

            dayListTo = calendarDates[activeTimeFrame].end[context.state.toYear][context.state.toMonth];

            let dayCount = new Date(parseInt(context.state.toYear), parseInt(context.state.toMonth), 0).getDate();
            for (var i = 1; i <= dayCount; i++) {

                let iNum = ("0" + i).slice(-2);

                if (dayListTo.includes(iNum) &&
                    parseInt(context.state.toYear + context.state.toMonth + iNum) >= parseInt(context.state.fromYear + context.state.fromMonth + context.state.fromDay)) {
                    dayListToObjs.push({
                        value: iNum,
                        text: iNum,
                        className: 'gc-calendar-item day',
                        isActive: iNum === context.state.toDay,
                        onClick: context.selectToDay.bind(null, iNum)
                    });
                } else {
                    dayListToObjs.push({
                        value: iNum,
                        text: iNum,
                        className: 'gc-calendar-item faded day',
                        isActive: iNum === context.state.toDay,
                        onClick: null
                    });
                }
            }

            monthListToObjs.forEach((obj) => {
                if (obj.isActive) {
                    obj.className += ' active-alt';
                    obj.onClick = context.selectToYear.bind(null, context.state.toYear);
                } else {
                    obj.className += ' hidden';
                    obj.onClick = null;
                }
            });
        } else {
            for (var i = 0; i < 31; i++) {
                dayListToObjs.push({
                    value: '',
                    text: '',
                    className: 'gc-calendar-item day hidden',
                    isActive: false,
                    onClick: null
                });
            }
        }
        if (context.state.toDay != null) {
            phase = 7;

            dayListToObjs.forEach((obj) => {
                if (obj.isActive) {
                    obj.className += ' active-alt';
                    obj.onClick = context.selectToMonth.bind(null, context.state.toMonth);
                } else {
                    obj.className += ' hidden';
                    obj.onClick = null;
                }
            });
        }

        yearListFromObjs.forEach((obj) => {
            finalDateObject.fromYear.push((
                <div
                    className={obj.className}
                    onClick={obj.onClick}
                    style={{ transitionDelay: (Math.random() / 3) + 's' }}>
                    {obj.text}
                </div>
            ));
        });
        monthListFromObjs.forEach((obj) => {
            finalDateObject.fromMonth.push((
                <div
                    className={obj.className}
                    onClick={obj.onClick}
                    style={{ transitionDelay: (Math.random() / 3) + 's' }}>
                    {obj.text}
                </div>
            ));
        });
        dayListFromObjs.forEach((obj) => {
            finalDateObject.fromDay.push((
                <div
                    className={obj.className}
                    onClick={obj.onClick}
                    style={{ transitionDelay: (Math.random() / 3) + 's' }}>
                    {obj.text}
                </div>
            ));
        });
        yearListToObjs.forEach((obj) => {
            finalDateObject.toYear.push((
                <div
                    className={obj.className}
                    onClick={obj.onClick}
                    style={{ transitionDelay: (Math.random() / 3) + 's' }}>
                    {obj.text}
                </div>
            ));
        });
        monthListToObjs.forEach((obj) => {
            finalDateObject.toMonth.push((
                <div
                    className={obj.className}
                    onClick={obj.onClick}
                    style={{ transitionDelay: (Math.random() / 3) + 's' }}>
                    {obj.text}
                </div>
            ));
        });
        dayListToObjs.forEach((obj) => {
            finalDateObject.toDay.push((
                <div
                    className={obj.className}
                    onClick={obj.onClick}
                    style={{ transitionDelay: (Math.random() / 3) + 's' }}>
                    {obj.text}
                </div>
            ));
        });

        finalDateObject.phase = phase;

        return finalDateObject;
    }

    didGetTicket(value, target, isUnder) {

        if (isUnder) {
            return value <= target;
        } else {
            return value >= target;
        }
    }

    generateMultiStoreBlastData(identity, locationMap) {
        return Object.values(identity.blastData.reduce((r, e) => {

            let key = e.name + "|" + e.dateIndex + "|" + e.goalContestReportKpi.reportKpiId;
            if (!r[key]) {
                r[key] = {
                    contestId: identity.contestId,
                    calEnd: e.calEnd,
                    calStart: e.calStart,
                    cyValue: e.cyValue,
                    date: e.date,
                    dateIndex: e.dateIndex,
                    goalContestReportKpi: e.goalContestReportKpi,
                    id: e.id,
                    locationId: e.locationId,
                    location: (locationMap != undefined && locationMap != null &&
                        locationMap[e.locationId] != undefined && locationMap[e.locationId] != null ? locationMap[e.locationId] : ''),
                    lyValue: e.lyValue,
                    name: e.name,
                    type: e.type,
                    userId: e.userId
                }
            } else {
                r[key].lyValue += e.lyValue;
                r[key].cyValue += e.cyValue;
                r[key].locationId = '';
                r[key].location = 'Multi-Location';
            }
            return r;
        }, {}));
    }

    generateContestPeriodData(identity, multiStoreBlastData) {
        return _.sortBy(Object.values(multiStoreBlastData.reduce((r, e) => {
            let key = moment(e.calStart.substring(0, e.calStart.length - 1)).format("YYYYMMDD");
            if (!r[key]) {
                r[key] = {
                    key: key,
                    startDateIndex: parseInt(key),
                    endDateIndex: parseInt(moment(e.calEnd.substring(0, e.calEnd.length - 1)).format("YYYYMMDD")),
                    calStart: e.calStart,
                    calEnd: e.calEnd,
                    contestId: identity.contestId,
                    contestType: identity.contestType,
                    kpiIdOne: identity.reportKPIIdOne,
                    kpiIdTwo: identity.reportKPIIdTwo,
                    kpiIdThree: identity.reportKPIIdThree,
                    kpiValueOne: identity.valueOne,
                    kpiValueTwo: identity.valueTwo,
                    kpiValueThree: identity.valueThree,
                    kpiUnderOne: identity.useUnderOne,
                    kpiUnderTwo: identity.useUnderTwo,
                    kpiUnderThree: identity.useUnderThree,
                    kpiIdMinOne: identity.reportKPIIdMinOne,
                    kpiIdMinTwo: identity.reportKPIIdMinTwo,
                    kpiIdMinThree: identity.reportKPIIdMinThree,
                    kpiValueMinOne: identity.valueMinOne,
                    kpiValueMinTwo: identity.valueMinTwo,
                    kpiValueMinThree: identity.valueMinThree,
                    kpiUnderMinOne: identity.useUnderMinOne,
                    kpiUnderMinTwo: identity.useUnderMinTwo,
                    kpiUnderMinThree: identity.useUnderMinThree,
                    type: identity.type,
                    blastData: [{
                        cyValue: e.cyValue,
                        dateIndex: e.dateIndex,
                        goalContestReportKpi: e.goalContestReportKpi,
                        locationId: e.locationId,
                        location: e.location,
                        lyValue: e.lyValue,
                        name: e.name,
                        type: e.type,
                        userId: e.userId
                    }]
                };
            } else {
                r[key].blastData.push({
                    cyValue: e.cyValue,
                    dateIndex: e.dateIndex,
                    goalContestReportKpi: e.goalContestReportKpi,
                    locationId: e.locationId,
                    location: e.location,
                    lyValue: e.lyValue,
                    name: e.name,
                    type: e.type,
                    userId: e.userId
                });
            }
            return r;
        }, {})), (obj) => { return parseInt(moment(new Date(obj.calStart)).format('YYYYMMDD')) })
    }

    generateContestPeopleData(identity) {
        let self = this;
        return Object.values(identity.blastData.reduce((r, e) => {
            let key = e.name;
            if (!r[key]) {
                r[key] = {
                    name: e.name,
                    locationId: e.locationId,
                    location: e.location,
                    userId: e.userId,
                    kpiOne: e.goalContestReportKpi.reportKpiId === identity.kpiIdOne ? e.cyValue : null,
                    kpiTwo: e.goalContestReportKpi.reportKpiId === identity.kpiIdTwo ? e.cyValue : null,
                    kpiThree: e.goalContestReportKpi.reportKpiId === identity.kpiIdThree ? e.cyValue : null,
                    kpiMinOne: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinOne ? self.didGetTicket(e.cyValue, identity.kpiValueMinOne, identity.kpiUnderMinOne) : null,
                    kpiMinTwo: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinTwo ? self.didGetTicket(e.cyValue, identity.kpiValueMinTwo, identity.kpiUnderMinTwo) : null,
                    kpiMinThree: e.goalContestReportKpi.reportKpiId === identity.kpiIdMinThree ? self.didGetTicket(e.cyValue, identity.kpiValueMinThree, identity.kpiUnderMinThree) : null
                }
            } else {
                if (e.goalContestReportKpi.reportKpiId === identity.kpiIdOne && identity.kpiIdOne != null) {
                    r[key].kpiOne = e.cyValue;
                } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdTwo && identity.kpiIdTwo != null) {
                    r[key].kpiTwo = e.cyValue;
                } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdThree && identity.kpiIdThree != null) {
                    r[key].kpiThree = e.cyValue;
                }

                if (r[key].locationId != e.locationId) {
                    r[key].location = 'Multi-Location';
                }

                if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinOne && identity.kpiIdMinOne != null) {
                    r[key].kpiMinOne = self.didGetTicket(e.cyValue, identity.kpiValueMinOne, identity.kpiUnderMinOne);
                } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinTwo && identity.kpiIdMinTwo != null) {
                    r[key].kpiMinTwo = self.didGetTicket(e.cyValue, identity.kpiValueMinTwo, identity.kpiUnderMinTwo);
                } else if (e.goalContestReportKpi.reportKpiId === identity.kpiIdMinThree && identity.kpiIdMinThree != null) {
                    r[key].kpiMinThree = self.didGetTicket(e.cyValue, identity.kpiValueMinThree, identity.kpiUnderMinThree);
                }
            }

            return r;
        }, {}));
    }

    generateContestCompetitionResults(tempResults, myUserId) {
        let finalResults = {
            topFive: [],
            me: {
                name: '',
                location: '',
                value: '',
                placement: -1
            }
        }

        if (tempResults.length > 0) {
            finalResults.topFive.push({
                name: tempResults[tempResults.length - 1].key,
                location: tempResults[tempResults.length - 1].location,
                value: tempResults[tempResults.length - 1].value,
                placement: 1
            });
        }
        if (tempResults.length > 1) {
            finalResults.topFive.push({
                name: tempResults[tempResults.length - 2].key,
                location: tempResults[tempResults.length - 2].location,
                value: tempResults[tempResults.length - 2].value,
                placement: 2
            });
        }
        if (tempResults.length > 2) {
            finalResults.topFive.push({
                name: tempResults[tempResults.length - 3].key,
                location: tempResults[tempResults.length - 3].location,
                value: tempResults[tempResults.length - 3].value,
                placement: 3
            });
        }
        if (tempResults.length > 3) {
            finalResults.topFive.push({
                name: tempResults[tempResults.length - 4].key,
                location: tempResults[tempResults.length - 4].location,
                value: tempResults[tempResults.length - 4].value,
                placement: 4
            });
        }
        if (tempResults.length > 4) {
            finalResults.topFive.push({
                name: tempResults[tempResults.length - 5].key,
                location: tempResults[tempResults.length - 5].location,
                value: tempResults[tempResults.length - 5].value,
                placement: 5
            });
        }
        if (myUserId != undefined && myUserId != null) {
            for (var i = 0; i < tempResults.length; i++) {
                if (tempResults.userId === myUserId) {
                    finalResults.me = {
                        name: tempResults[i].key,
                        location: tempResults[i].location,
                        value: tempResults[i].value,
                        placement: tempResults.length - i
                    }
                }
            }
        }

        return finalResults;
    }
}